import { Chip, styled } from "@mui/material";

const ChipCustom = styled(Chip)(({ theme }) => ({
  "&.MuiChip-root": {
    fontSize: "14px",
    borderRadius: "0.3755rem",
  },
  "&.MuiChip-colorError": {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.main,
  },
  "&.MuiChip-colorWarning": {
    "backgroundColor": theme.palette.warning.light,
    "color": theme.palette.warning.dark,

  },
  "&.MuiChip-colorPrimary": {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
  },
  "&.MuiChip-colorInfo": {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.main,
  },
  "&.MuiChip-colorSuccess": {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.main,
  },
  "&.MuiChip-colorSecondary": {
    backgroundColor: theme.palette.gray.light,
    color: theme.palette.gray.main,
  },
}));

export default ChipCustom;
